import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

/** Single state for user selection from the missing-entities product/collection modal. */
export interface MissingEntitiesSelection {
  /** productId -> variantIds[] (for SPECIFIC_PRODUCT) */
  productSelection?: Record<string, string[]>;
  /** For product collection mode */
  collectionSelection?: { id: string; name: string }[];
}

interface MissingEntitiesModalState {
  isOpen: boolean;
  /** Requested entity types from the AI chatbot, e.g. ['product_id', 'product_ids', 'collection_id'] */
  missingEntities: string[];
  /** User's selection from the modal (products and/or collections) */
  selection: MissingEntitiesSelection;
}

const initialState: MissingEntitiesModalState = {
  isOpen: false,
  missingEntities: [],
  selection: {},
};

const missingEntitiesSlice = createSlice({
  name: "missingEntities",
  initialState,
  reducers: {
    openMissingEntitiesModal: (state, action: PayloadAction<{ missingEntities: string[] }>) => {
      state.isOpen = true;
      state.missingEntities = action.payload.missingEntities ?? [];
      state.selection = {};
    },
    closeMissingEntitiesModal: (state) => {
      state.isOpen = false;
      state.missingEntities = [];
    },
    setMissingEntitiesSelection: (state, action: PayloadAction<MissingEntitiesSelection>) => {
      state.selection = { ...state.selection, ...action.payload };
    },
  },
});

export const {
  openMissingEntitiesModal,
  closeMissingEntitiesModal,
  setMissingEntitiesSelection,
} = missingEntitiesSlice.actions;

export const selectMissingEntitiesModal = (state: RootState) => state.missingEntities;

export default missingEntitiesSlice.reducer;
